import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class StoreReturnDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Store Return id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  storeReturnId?: number;
  @ApiProperty()
  saleOrderId: number;
  @ApiProperty()
  storeReturnDate: Date;
  @ApiProperty()
  itemCategoryId: number;
  @ApiProperty()
  storeConsumptionId: number[];
  @ApiProperty()
  returnReason: string;
  @ApiProperty()
  unitId:number
  @ApiProperty()
  itemId: number;
  @ApiProperty()
  @MaxLength(15, { message: "Store Return No allows maximum 50 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Store Return No should be only alpha numeric" })
  storeReturnNo: string;
  
  @ApiProperty()
  returnQuantity:number;

  @ApiProperty()
  remarks:string;
  @ApiProperty()
  approvar:string;

  @ApiProperty()
  status: string;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
  
  @ApiProperty()
  isDamaged : boolean;

  @ApiProperty()
  locationId : number;

  @ApiProperty()
  itemSubCategory?: number;

  
}

